module.exports = __webpack_public_path__ + "img/tooth10.cc16d003.png";